var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTongue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09617 4.50272C2.3207 4.05366 2.86676 3.87164 3.31582 4.09617L4.78374 4.83013C9.32648 7.1015 14.6735 7.1015 19.2163 4.83013L20.6842 4.09617C21.1332 3.87164 21.6793 4.05366 21.9038 4.50272C22.1284 4.95178 21.9463 5.49784 21.4973 5.72237L20.0294 6.45633C19.5573 6.69235 19.0775 6.90632 18.5913 7.09826V12.8637C18.5913 16.5037 15.6405 19.4545 12.0005 19.4545C8.36054 19.4545 5.40974 16.5037 5.40974 12.8637V7.09867C4.9232 6.90663 4.44302 6.69252 3.97065 6.45633L2.50272 5.72237C2.05366 5.49784 1.87164 4.95178 2.09617 4.50272ZM12.9094 8.32878C14.2108 8.26282 15.5066 8.0552 16.7732 7.70592V12.8637C16.7732 15.4995 14.6364 17.6363 12.0005 17.6363C9.36467 17.6363 7.22789 15.4995 7.22789 12.8637V7.70621C8.49433 8.05538 9.79005 8.26291 11.0913 8.32881V12.8637C11.0913 13.3657 11.4983 13.7727 12.0004 13.7727C12.5024 13.7727 12.9094 13.3657 12.9094 12.8637V8.32878Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongue);
export default __webpack_public_path__ + "static/media/tongue.14d2f34ca32978f7a07412770f6a61a0.svg";
export { ForwardRef as ReactComponent };